module.exports = __webpack_public_path__ + "img/thanos_marvel_feature.e4fd23aa.jpg";